import _ from 'lodash'
import {db} from '@/firebaseInit'
// const debug = require('debug')('OD::Lib:Data:Data')

export default {
  filter(items, filterText, sortFunction) {
    // debug('itemsFiltered', filterText)
    let itemsFiltered = items
    // remove hide item
    itemsFiltered = itemsFiltered.filter(item => {
      return !item.hide
    })
    if (filterText) {
      itemsFiltered = itemsFiltered.filter(item => {
        let found = false
        Object.keys(item).forEach(key => {
          if (
            item[key] &&
            ![
              'id',
              'created',
              'updated',
              'createdBy',
              'updatedBy',
              'createdByName',
              'updatedByName',
            ].includes(key)
          ) {
            if (
              item[key]
                .toString()
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) > -1
            ) {
              found = true
            }
          }
        })
        return found
      })
    }
    if (sortFunction) {
      // items = state.sortFunction(items)
    }
    return itemsFiltered
  },
  groupBy(items, groupBy) {
    let array = []
    if (groupBy) {
      array = _.groupBy(items, function(item) {
        return item[groupBy]
      })
      if (groupBy === 'type') {
        const result = {}
        if (array.event) result.event = array.event
        if (array.club) result.club = array.club
        return result
      }
      return array
    }
    array.push(items)
    return array
  },
  bindItem(vm, clubId) {
    vm.loading_test = true
    vm
      .$bind('club', db.collection('clubs').doc(clubId))
      .then(club => {
        vm.loadingClub = false
      })
      .catch(error => {
        vm.loadingClub = false
        vm.dbErrors.club = error
      })
  },
  add(vm, item) {
    vm.$firestoreRefs.clubs.add(item)
  },
  update(vm, clubId, item) {
    vm.$firestoreRefs.clubs.doc(clubId).update(item)
  },
  delete(vm, clubId, item) {
    vm.$firestoreRefs.clubs.doc(clubId).delete()
  },
}
